import { CheckCircle, Clock, Refresh, XmarkCircle } from 'iconoir-react';
import { cn } from 'lib/utils';
import type { TopUpTone } from '../utils/topup-outcome';

const TONES = {
  waiting: { Icon: Refresh, className: 'animate-spin text-muted-foreground' },
  pending: { Icon: Clock, className: 'text-muted-foreground' },
  success: { Icon: CheckCircle, className: 'text-success-green' },
  failure: { Icon: XmarkCircle, className: 'text-destructive' },
};

export const TopUpToneIcon = ({ tone, className }: { tone: TopUpTone; className?: string }) => {
  const { Icon, className: toneClass } = TONES[tone];
  return <Icon aria-hidden="true" className={cn(toneClass, className)} />;
};
